import React from 'react';
import styles from './Subscription.module.css'
import axios from 'axios';

const Subscription = () => {

    const handleSubscribe = async () => {
        try {
            const res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/subscription/trader`,
                {},
                { withCredentials: true, validateStatus: () => true }
            );
            if (res.data?.url) {
                window.location.href = res.data.url;
            } else {
                console.error("Erreur : URL de redirection manquante");
            }
        } catch (error) {
            console.error("Erreur lors de la création de la session :", error);
        }
    };

    return (
        <div className={styles.card}>
            <img className={styles.logo} src='/Asset/logo.png' alt=''/>
            <h1 className={styles.title}>🚀 OFFRE DE LANCEMENT</h1>
            <div className={styles.list}>
                <li className={styles.option}>✔️ Mise en avant et référencement sur notre site</li>
                <li className={styles.option}>✔️ Visibilité sur nos réseaux sociaux</li>
                <li className={styles.option}>✔️ Diffusion de vos offres</li>
            </div>
            <div className={styles.subscription}>
                <h2 className={styles.amount}><span className={styles.price}>10,83 €</span> HT / mois</h2>
                <p className={styles.describe}>soit 12,99 € TTC / mois. Sans engagement, résiliable à tout moment</p>
            </div>
            <button onClick={handleSubscribe} className={styles.btn}>S'abonner</button>
        </div>
    );
};

export default Subscription;